import './trailingSlash.js'
import './subpage.css'
import { initMcpInstall } from './mcpInstall'
import { initSiteHeader } from './siteHeader'
import { initSiteFooter } from './siteFooter'

initSiteHeader()
initSiteFooter()
initMcpInstall()
